var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPeopleBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78052 11.7817C10.6445 11.7817 12.1555 10.2707 12.1555 8.40674C12.1555 6.54278 10.6445 5.03174 8.78052 5.03174C6.91656 5.03174 5.40552 6.54278 5.40552 8.40674C5.40552 10.2707 6.91656 11.7817 8.78052 11.7817Z",
    fill: "#B7B9BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0304 19.0317H3.53039C3.38407 19.0317 3.23954 18.9995 3.10701 18.9375C2.97447 18.8755 2.85716 18.7852 2.76334 18.6729C2.66953 18.5606 2.6015 18.4291 2.56406 18.2876C2.52661 18.1462 2.52067 17.9982 2.54664 17.8542C3.07664 14.7817 5.66539 12.6567 8.78039 12.6567C11.8954 12.6567 14.4841 14.7817 15.0154 17.8542C15.0414 17.9983 15.0354 18.1464 14.9979 18.2879C14.9604 18.4295 14.8922 18.561 14.7983 18.6734C14.7043 18.7857 14.5869 18.876 14.4542 18.9379C14.3215 18.9998 14.1768 19.0319 14.0304 19.0317Z",
    fill: "#B7B9BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2808 11.7817C17.1447 11.7817 18.6558 10.2707 18.6558 8.40674C18.6558 6.54278 17.1447 5.03174 15.2808 5.03174C13.4168 5.03174 11.9058 6.54278 11.9058 8.40674C11.9058 10.2707 13.4168 11.7817 15.2808 11.7817Z",
    fill: "#3987F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5306 19.0317H10.0306C9.88431 19.0317 9.73979 18.9995 9.60725 18.9375C9.47471 18.8755 9.3574 18.7852 9.26359 18.6729C9.16977 18.5606 9.10174 18.4291 9.0643 18.2876C9.02686 18.1462 9.02091 17.9982 9.04689 17.8542C9.57689 14.7817 12.1656 12.6567 15.2806 12.6567C18.3956 12.6567 20.9844 14.7817 21.5156 17.8542C21.5416 17.9983 21.5357 18.1464 21.4981 18.2879C21.4606 18.4295 21.3925 18.561 21.2985 18.6734C21.2046 18.7857 21.0871 18.876 20.9544 18.9379C20.8217 18.9998 20.6771 19.0319 20.5306 19.0317Z",
    fill: "#3987F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPeopleBlue);
export default __webpack_public_path__ + "static/media/icon_people_blue.ae9e28c9.svg";
export { ForwardRef as ReactComponent };